import React from "react";
import NumberButton from "./NumberButton";

export default function LotteryCard({ card, selected, onNumberClick }) {
  return (
    <div className="bg-slate-900 rounded-2xl p-4 shadow-2xl flex flex-col items-center">
      <div className="mb-2 flex justify-between w-full">
        <div>
          <span className="text-sm text-gray-300">Card #{card.id}</span>
        </div>
        <div className="font-bold text-green-400">
          {card.filled.length}/100 Picked
        </div>
      </div>

      <div className="grid grid-cols-10 gap-2">
        {[...Array(100).keys()].map((num) => (
          <NumberButton
            key={num}
            number={String(num).padStart(2, "0")} // two digits always
            isFilled={card.filled.includes(num)}
            isSelected={selected.includes(num)}
            onClick={() => onNumberClick(num)}
            owner={card.owners && card.owners[num] ? card.owners[num] : null}
          />
        ))}
      </div>

      <div className="text-gray-400 mt-3 text-sm">
        1 number = $0.5 | 8000% to winner ($40 for each Lottery Card)
      </div>
    </div>
  );
}
